/**
 * Plan types
 */
const PLAN_TYPES = {
  plan: "Plan",
  variablePricePlan: "VariablePricePlan",
  globalPlan: "GlobalPlan",
};

const PLAN_BILLING_UNITS = {
  yearly: "yearly",
  monthly: "monthly",
};

export { PLAN_TYPES, PLAN_BILLING_UNITS };
